import React from 'react';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';
import { navigate } from 'js/services/Network';
import { Spring, animated } from 'react-spring';

import { lightGrey1Color } from 'js/config/style';
import { url } from 'js/services/Network';
import analytics from 'js/services/Analytics';
import AppUser from 'js/stores/AppUser';

import AppContent from 'js/components/AppContent';
import PageComponent from 'js/components/pages/PageComponent';
import Backdrop from 'js/components/core/Backdrop';
import LoginSignupDialog from 'js/components/common/LoginSignupDialog';

@observer
export default class LoginPage extends PageComponent {
  pageName = 'LoginPage';
  pageColor = lightGrey1Color;

  constructor(props) {
    super(props);
    this.loggedInReaction = reaction(() => AppUser.isLoggedIn, isLoggedIn => isLoggedIn && navigate(url('home-page')));

    if (AppUser.isLoggedIn) {
      navigate(url('home-page'));
    }
  }

  componentWillUnmount() {
    this.loggedInReaction();
  }

  pageEvent = () => { /*analytics.page('Login')*/ };

  renderPage() {
    let hasReferral = this.props.location.search.startsWith('?referral=');
    let referral = '';
    if(hasReferral){
      referral = this.props.location.search.split('=')[1];
    }
    let formType = hasReferral ? 'signup' : 'login';
    return (
      <AppContent padded>
        <Backdrop>
          <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
            {animation => (
              <animated.div style={animation}>
                <LoginSignupDialog
                  showForm={formType}
                  loginTitle="Log in to your account"
                  signupTitle="Create an account"
                  signupText="to start using the safest way to buy and sell on any marketplace."
                  referral={referral}
                  padded
                  termsOfService
                  singleUseToken={this.props?.singleUseToken}
                />
              </animated.div>
            )}
          </Spring>
        </Backdrop>
      </AppContent>
    );
  }
}
